import { useCallback, useEffect, useState } from "react";

import type { NgwWebmapItem } from "@nextgis/ngw-kit";

import {
  type LayerTreeOptions,
  getBranchIndeterminate,
  getLayerVisible,
} from "../utils/layers";

export function useLayerVisibility(
  layer: NgwWebmapItem,
  options: LayerTreeOptions,
) {
  const getState = useCallback(
    () => ({
      visible: getLayerVisible(layer, options),
      indeterminate: getBranchIndeterminate(layer, options),
    }),
    [layer, options],
  );
  const [state, setState] = useState(getState);

  useEffect(() => {
    const visibility = layer.properties?.property("visibility");
    if (!visibility) return;

    const update = () => setState(getState());
    visibility.emitter.on("change", update);
    visibility.emitter.on("change-tree", update);
    update();

    return () => {
      visibility.emitter.removeListener("change", update);
      visibility.emitter.removeListener("change-tree", update);
    };
  }, [getState, layer]);

  return state;
}
